import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './adBanner.scss';

class AdBanner extends Component {
  render() {
    if (!this.props.html) return null;

    const classes = `ad-banner ${this.props.className || ''}`;

    return (
      <div className={classes} dangerouslySetInnerHTML={{__html: this.props.html}} />
    );
  }
}

AdBanner.propTypes = {
  html: PropTypes.string,
  className: PropTypes.string
};


export default AdBanner;


// WEBPACK FOOTER //
// ./src/screens/components/adBanner/AdBanner.jsx